import { ArgumentNullError } from '../ArgumentNullError'
import { globalState } from '../globalState'
import { logError } from './logging'

export const tryCatch = <T extends (...args: any[]) => any>(fn: T): T =>
    ((...args: any[]) => {
        try {
            return fn(...args)
        } catch (error) {
            logError(error)
            throwCxfError(error as Error)
        }
    }) as T

export const throwCxfError = (e: Error): void => {
    const config = globalState.getConfig()
    const cxf = globalState.getCxf()
    cxf.emit(config.CXF_ERROR, e)
}

export const isArgumentNullError = (e: Error): e is ArgumentNullError => e.name === 'ArgumentNullError'
